module.exports = __webpack_public_path__ + "img/icvNum.af30f69c.png";